import script from "./UnifiedPatchNotesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UnifiedPatchNotesPage.vue?vue&type=script&setup=true&lang=js"

import "./UnifiedPatchNotesPage.vue?vue&type=style&index=0&id=5f8bd2c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f8bd2c7"]])

export default __exports__